import { renderSlot as _renderSlot, mergeProps as _mergeProps, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("button", _mergeProps({ class: "inline-flex items-center rounded-full p-2" }, _ctx.$attrs, {
    class: { outlined: _ctx.isOutlined, main: _ctx.isMain, disabled: _ctx.$attrs.disabled }
  }), [
    _renderSlot(_ctx.$slots, "default", {}, undefined, true)
  ], 16))
}